import apiCrud from '../../abstract/api-crud';

const baseUri = `${ import.meta.env.VITE_SITE_URL }/zus/packages`;
export const modelName = 'zusdeclarationspackage';

export default {
  ...apiCrud({ baseUri, modelName }),
};
